import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ProductType } from 'app/shared/model/enumerations/product-type.model';
import { UnitType } from 'app/shared/model/enumerations/unit-type.model';
import { createEntity, getEntity, reset, updateEntity } from './dynamic-tariff.reducer';

export const DynamicTariffUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const dynamicTariffEntity = useAppSelector(state => state.dynamicTariff.entity);
  const loading = useAppSelector(state => state.dynamicTariff.loading);
  const updating = useAppSelector(state => state.dynamicTariff.updating);
  const updateSuccess = useAppSelector(state => state.dynamicTariff.updateSuccess);
  const productTypeValues = Object.keys(ProductType);
  const unitTypeValues = Object.keys(UnitType);

  const handleClose = () => {
    navigate('/dynamic-tariff');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    values.from = convertDateTimeToServer(values.from);
    values.until = convertDateTimeToServer(values.until);

    const entity = {
      ...dynamicTariffEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          from: displayDefaultDateTime(),
          until: displayDefaultDateTime(),
        }
      : {
          productType: 'ELECTRICITY',
          unit: 'KWH',
          ...dynamicTariffEntity,
          from: convertDateTimeFromServer(dynamicTariffEntity.from),
          until: convertDateTimeFromServer(dynamicTariffEntity.until),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.dynamicTariff.home.createOrEditLabel" data-cy="DynamicTariffCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.dynamicTariff.home.createOrEditLabel">
              Create or edit a DynamicTariff
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="dynamic-tariff-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.dynamicTariff.price')}
                id="dynamic-tariff-price"
                name="price"
                data-cy="price"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.dynamicTariff.from')}
                id="dynamic-tariff-from"
                name="from"
                data-cy="from"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.dynamicTariff.until')}
                id="dynamic-tariff-until"
                name="until"
                data-cy="until"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.dynamicTariff.productType')}
                id="dynamic-tariff-productType"
                name="productType"
                data-cy="productType"
                type="select"
              >
                {productTypeValues.map(productType => (
                  <option value={productType} key={productType}>
                    {translate(`crawlerBackendApp.ProductType.${productType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.dynamicTariff.unit')}
                id="dynamic-tariff-unit"
                name="unit"
                data-cy="unit"
                type="select"
              >
                {unitTypeValues.map(unitType => (
                  <option value={unitType} key={unitType}>
                    {translate(`crawlerBackendApp.UnitType.${unitType}`)}
                  </option>
                ))}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/dynamic-tariff"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DynamicTariffUpdate;
